import { h } from "preact";
import ReactSlider from "react-slider";

import { classNames } from "../helpers";

class SliderSelector {
  constructor(values) {
    this.values = values;
  }

  from(v) {
    return this.values.indexOf(v);
  }

  to(v) {
    return this.values[parseInt(v, 10)];
  }
}

export default function Slider({
  disabled,
  max,
  min,
  onChange,
  step,
  value,
  range,
  possibleValues,
  minDistance,
  label,
  getTooltip,
  ...props
}) {
  function handleChange(value) {
    if (range) {
      onChange(
        possibleValuesKeys.length
          ? value.map((v) => possibleValuesKeys[parseInt(v, 10)])
          : value
      );
    } else {
      onChange(possibleValuesKeys[parseInt(value, 10)] || value);
    }
  }
  let tooltips = range ? [true, true] : true;
  let possibleValuesValues = [];
  let possibleValuesKeys = [];

  if (possibleValues) {
    if (Array.isArray(possibleValues)) {
      min = 0;
      max = possibleValues.length - 1;
      possibleValuesValues = possibleValues;
    } else {
      min = 0;
      max = Object.values(possibleValues).length - 1;
      possibleValuesValues = Object.values(possibleValues);
    }
    possibleValuesKeys = Object.keys(possibleValues).map((x) =>
      parseInt(x, 10)
    );

    tooltips = range
      ? [new SliderSelector(possibleValues), new SliderSelector(possibleValues)]
      : new SliderSelector(possibleValues);
  }

  let defaultValue = 0;
  if (range) {
    defaultValue = possibleValuesKeys.length
      ? [
          possibleValuesKeys.indexOf(value[0]),
          possibleValuesKeys.indexOf(value[1]),
        ]
      : value;
  } else {
    defaultValue = possibleValuesKeys.length
      ? possibleValuesKeys.indexOf(value)
      : value;
  }

  return (
    <ReactSlider
      disabled={disabled}
      min={min}
      max={max}
      marks
      className={classNames(
        "slider",
        range ? "slider--range" : "slider--single",
        props.class
      )}
      minDistance={minDistance || 0}
      pearling={true}
      ariaLabel={label}
      defaultValue={defaultValue}
      onChange={handleChange}
      renderThumb={(props, state) => (
        <div class="thumb" {...props}>
          <div class="handle"></div>
          <div
            class={classNames(
              "tooltip",
              range && state.index == 0 && "tooltip--left"
            )}
          >
            <span>
              {possibleValues
                ? possibleValuesValues[state.valueNow]
                : getTooltip && getTooltip(state.valueNow)}
            </span>
          </div>
        </div>
      )}
    />
  );
  /*
      <div
      ref={inputRef}
      class={classNames(props.class, "slider slider--range")}
      id={`range-slider-${id}`}
      role="imput"
      tabindex="0"
    ></div>
*/
}
